import type { SetupOverviewItem, SetupType } from '../../../services/setupOverview/setupOverviewService';

export type CategorySetupFilter = 'all' | 'missing' | 'complete';
export type CostSetupFilter = 'all' | 'missing' | 'noIngredients' | 'complete';

export function filterSetupItems(items: SetupOverviewItem[], filters: {
  restaurantId?: string; type: SetupType; search: string;
  category: CategorySetupFilter; cost: CostSetupFilter;
}) {
  const search = filters.search.trim().toLocaleLowerCase();
  return items.filter(item => {
    if (filters.restaurantId && item.restaurantId !== filters.restaurantId) return false;
    if (filters.type !== 'all' && item.type !== filters.type) return false;
    if (search && !`${item.itemName} ${item.restaurantName}`.toLocaleLowerCase().includes(search)) return false;
    if (filters.category === 'missing' && item.categorized) return false;
    if (filters.category === 'complete' && !item.categorized) return false;
    if (filters.cost === 'noIngredients' && item.ingredientCount !== 0) return false;
    if (filters.cost === 'missing' && (item.type === 'other' || item.costSetUp)) return false;
    if (filters.cost === 'complete' && (item.type === 'other' || !item.costSetUp)) return false;
    return true;
  }).sort((a, b) => a.itemName.localeCompare(b.itemName) || a.restaurantName.localeCompare(b.restaurantName));
}
